export function resolveRequestedTenantDomain(search: string, _hostname: string) {
  const queryTenantDomain = normalizeTenantDomain(new URLSearchParams(search).get('tenantDomain'))
  if (queryTenantDomain) return queryTenantDomain
  return ''
}

function normalizeTenantDomain(value?: string | null) {
  return value?.trim().toLowerCase() ?? ''
}
